/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState, ChangeEvent } from "react";
import { TablePagination } from "@mui/material";
import CommonTable from "../../../components/CommonTable";
import PopupModules from "src/features/auth/components/PopupModules";
import LoadingScreen from "../../../../../shared/components/LoadingScreen";
import { notifyError, notifySuccess, notifyWarning } from "../../../../../assets/toastService";
import { exportProduct, importProduct } from "../../../../../shared/services/services";
import { ProductItem } from "../../../../../shared/services/interface";
import useProducts from "../../../hooks/useProducts";
import useCategory from "../../../hooks/useCategory";
import AddProducts from "./AddProducts";
import EditProducts from "./EditProducts";
import { useSearch } from "../../../components/SearchContext";
import { Button } from "src/business-types/grocery/components/Button";
import { ProductRow, Table } from "../settingInterface";
import InputBox from "src/business-types/grocery/components/InputBox";
import DropdownSelect from "src/business-types/grocery/components/DropdownSelect";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";
import { useUser } from "src/business-types/grocery/components/UserContext";
import { enableStock } from "../../Home/ProductDisplay";
import { useFormatAmount } from "src/business-types/laundry/modules/home/hooks/useFormatAmount";
import iconMap from "src/assets/icons/Icons";
import usePermission from "src/business-types/grocery/hooks/usePermission";

const productHeaderCell: Table<ProductRow>[] = [
  { id: "S.No", label: "S.No", numeric: false, sorting: false },
  { id: "Image", label: "Product Image", numeric: false, sorting: false },
  { id: "ProductName", label: "Products Name", numeric: false },
  { id: "ArabicName", label: "Other Name", numeric: false },
  { id: "category_name", label: "Category Type", numeric: false },
  { id: "PriceDetails", label: "Price Details (QR)", numeric: false, align: "left", sorting: false },
  { id: "Amount", label: "Final price(QR)", numeric: true, align: "right" },
  { id: "amountMeasurement", label: "Price/unit", numeric: false, sorting: false },
  ...(enableStock ? ([{ id: "stock", label: "Stock /min-qty", numeric: true, align: "right" }] as const) : []),
];

export default function Products({ usedPopup = false }: { usedPopup?: boolean }) {
  const [addProduct, setAddProduct] = useState(false);
  const [editProduct, setEditProduct] = useState<ProductItem>();
  const [confirmDeleteList, setConfirmDeleteList] = useState<string[]>();
  const [deleteIds, setDeleteIds] = useState<string[]>();
  const [deleted, setDeleted] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [filterCategory, setFilterCategory] = useState("");
  const [page, setPage] = useState(0);
  const { userConfigration } = useUser();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showDropdown, setShowDropdown] = useState(false);
  const DownArrow = iconMap["down"];
  const { hasPermission } = usePermission()
  const checkPermission = (productPermission: string) => hasPermission(productPermission)
  const createProduct = checkPermission("product_create")
  const updateProduct = checkPermission("product_update")
  const deletedProduct = checkPermission("product_deleted")

  //sorting
  const [orderby, setOrderBy] = useState("");
  const [field, setField] = useState("");

  const { searchTerm, setSearchTerm } = useSearch();
  const { category } = useCategory();
  const { product, loadingPro, productPage, DeletedProduct, reloadProduct, categoryidBased, searchProduct } = useProducts(
    deleted,
    page + 1,
    rowsPerPage,
    field,
    orderby,
  );
  const amountFormat = useFormatAmount();

  useEffect(() => {
    if (filterCategory) {
      categoryidBased(filterCategory);
    } else {
      categoryidBased("");
    }
  }, [filterCategory]);

  useEffect(() => {
    searchProduct(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    setDeleteIds(undefined);
    setConfirmDeleteList(undefined);
  }, [product]);

  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    console.log(userConfigration.tableDefultSize);
    setRowsPerPage(userConfigration?.tableDefultSize || 10);
    if (usedPopup) return;
    setSearchTerm("");
  }, []);

  const handleClose = (data?: any) => {
    setAddProduct(false);
    setEditProduct(undefined);
    setConfirmDeleteList(undefined);
    setDeleteIds(undefined);
    reloadProduct();
  };

  const calculateDiscountAmount = (discount: string | number | undefined, price: number): number => {
    if (!discount) return 0;

    const value = String(discount).trim();

    // Percentage discount
    if (value.endsWith("%")) {
      const percent = parseFloat(value.replace("%", ""));
      if (isNaN(percent)) return 0;
      return (price * percent) / 100;
    }

    // Flat amount discount
    const amount = parseFloat(value);
    return isNaN(amount) ? 0 : amount;
  };

  /** 🔹 Table Data Mapper */
  const tableData: ProductRow[] =
    product?.map((item, index) => ({
      "S.No": page * rowsPerPage + index + 1,
      id: item._id.$oid,
      ProductName: item.ProductName,
      ArabicName: item.ArabicName,
      category_name: item.category_name,
      PriceDetails: (
        <div className='flex flex-col text-sm text-gray-700'>
          <div className='flex w-full justify-between'>
            <p>Purchase :</p>
            <p>{amountFormat(Number(item.purchasePrice)) ?? 0.0}</p>
          </div>
          <div className='flex w-full justify-between'>
            <p>Selling :</p>
            <p>{amountFormat(Number(item.sellingPrice)) ?? 0.0}</p>
          </div>
          <div className='flex w-full justify-between'>
            <p>Discount :</p>
            <p>{calculateDiscountAmount(item.discount || "0", Number(item.sellingPrice) || 0)}</p>
          </div>
        </div>
      ),
      Amount: item.Amount,
      Image: item.image_url ?? "",
      stock: item.stock || 0,
      amountMeasurement: item.uom.filter((u) => u._id === item.amountMeasurement)[0]?.uomName || item.amountMeasurement,
    })) ?? [];

  /** 🔹 Pagination Handlers */
  const handlePageChange = (_: unknown, newPage: number) => setPage(newPage);
  const handleRowsChange = (e: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  /** 🔹 Delete Confirmation */
  const handleDelete = (selectedIds: (string | number)[]) => {
    const ids = selectedIds.map(String);
    setDeleteIds(ids);
    const names = product.filter((p) => ids.includes(p._id.$oid)).map((p) => p.ProductName);
    setConfirmDeleteList(names);
  };

  const confirmDelete = async () => {
    if (!deleteIds) return;
    DeletedProduct(deleteIds);
  };

  /** 🔹 Export Handler */
  const handleExport = async () => {
    setLoading(true);
    try {
      const res = await exportProduct();
      const blob = new Blob([res.data], { type: res.headers["content-type"] });
      const filename = res.headers["content-disposition"]?.match(/filename="?(.+)"?/)?.[1] || "product_export.xlsx";
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } catch (err) {
      notifyError("Failed to export products");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /** 🔹 Import Handler */
  const handleImportClick = () => fileInputRef.current?.click();

  const handleImportFile = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      await importProduct(formData);
      reloadProduct();
      notifySuccess("Products imported successfully");
    } catch (err) {
      notifyError("Import failed");
      console.error(err);
    }
  };

  return (
    <div className='w-full h-full overflow-auto bg-white rounded-2xl shadow m-1'>
      {/* 🔹 Filter & Action Bar */}
      <div className='flex justify-end items-center h-[12%]'>
        <div className='w-full flex gap-2 pr-12 justify-end'>
          {usedPopup && (
            <div className='col-span-2 md:col-span-3 flex justify-center items-center gap-2'>
              <p>Search</p>
              <InputBox value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} placeholder='Search Product' />
            </div>
          )}
          {/* View Deleted */}
          {!usedPopup && (
            <div className='flex items-center cursor-pointer gap-2' onClick={() => setDeleted(!deleted)}>
              <input type='checkbox' className='w-5 h-5' checked={deleted} onChange={(e) => setDeleted(e.target.checked)} />
              <p className='w-40'>View deleted</p>
            </div>
          )}
          {/* Category Filter */}
          <div className={`col-span-2 md:col-span-2 flex flex-col justify-center items-start w-80 mt-3`}>
            <p className='text-sm font-medium col-span-2 w-28 -mt-2'>Category Type</p>
            <div className='w-52 h-fit'>
              <DropdownSelect
                titleofSelect='All Category'
                name='category_id'
                value={filterCategory}
                options={category.map((c) => ({ _id: c._id.$oid, CategoryName: c.CategoryName, otherName: c.categorySecondName }))}
                onChange={(e) => setFilterCategory(e)}
              />
            </div>
          </div>

          {/* Actions */}
          {(!usedPopup && createProduct) && <Button label='+ Product' variant='ThemeBase' onClick={() => setAddProduct(true)} className="p-2 w-fit h-fit mt-4" />}
          {!usedPopup && (
            // <Button variant='ThemeBase' onClick={() => {setShowDropdown(!showDropdown)}} icon={DownArrow} iconPosition='right' label='More Options' className="p-2 w-fit h-fit mt-4" />
            <Button variant='ThemeBase' onClick={() => { notifyWarning("Comming Zoon") }} icon={DownArrow} iconPosition='right' label='More Options' className="p-2 w-fit h-fit mt-4" />
          )}
          <input type='file' accept='.xlsx,.xls,.csv' ref={fileInputRef} className='hidden' onChange={handleImportFile} />
          {showDropdown && (
            <div className='absolute mt-16 right-16 bg-white border rounded shadow-lg z-10 w-32'>
              <button
                className='w-full px-4 py-2 text-left hover:bg-gray-100'
                onClick={() => {
                  handleExport();
                  setShowDropdown(false);
                }}
              >
                Export
              </button>

              <button
                className='w-full px-4 py-2 text-left hover:bg-gray-100'
                onClick={() => {
                  handleImportClick();
                  setShowDropdown(false);
                }}
              >
                Import
              </button>
            </div>
          )}
        </div>
      </div>

      {/* 🔹 Product Table */}
      <div className='mx-1 -mt-3  flex justify-center'>
        <div className='w-full'>
          <CommonTable<ProductRow>
            data={tableData}
            headCells={productHeaderCell}
            title={""}
            onDeleteSelected={handleDelete}
            onEditSelected={(id) => { if (updateProduct) { setEditProduct(product.find((p) => p._id.$oid === id)) } else { notifyWarning("Product update access is restricted for your account. Please contact your business owner or admin.") } }}
            selectable={false}
            pagenation={false}
            pageSize={rowsPerPage}
            Action={!deleted && !usedPopup}
            shortByTable={false}
            OrderType={(data) => {
              setField(data.field);
              setOrderBy(data.orderby);
            }}
          />
          <div className='w-[95%] mx-auto border-t mt-2'>
            <TablePagination
              rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
              component='div'
              count={productPage?.totalRecords ?? 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsChange}
            />
          </div>
        </div>
      </div>

      {/* 🔹 Modals */}
      {addProduct && <AddProducts close={handleClose} category={category} loading={setLoading} addProduct={addProduct} />}
      {editProduct && <EditProducts editData={editProduct} close={handleClose} category={category} loading={setLoading} />}

      {/* Delete Confirmation */}
      {confirmDeleteList && (
        <PopupModules isOpen onClose={() => handleClose()} title='Confirm Deletion'>
          <div className='px-4 py-3 text-center'>
            <p className='text-sm text-gray-600 mb-4'>
              The following products will be <span className='text-red-600 font-semibold'>DELETED</span>.
              <br />
              This action <span className='font-bold'>cannot be undone.</span>
            </p>
            <div className='max-h-40 overflow-y-auto bg-gray-50 border rounded-md p-3 mb-5'>
              {confirmDeleteList.map((name, i) => (
                <div key={i} className='text-sm text-gray-700 py-1 border-b last:border-0'>
                  {i + 1}. {name}
                </div>
              ))}
            </div>
            <div className='flex justify-center gap-4'>
              <Button label='Cancel' variant='cancel' onClick={() => handleClose()} />
              <Button label='Delete' variant='danger' onClick={confirmDelete} />
            </div>
          </div>
        </PopupModules>
      )}
      {(loadingPro || isLoading) && <LoadingScreen />}
    </div>
  );
}
